<script>
import $dayjs from '@/services/date'

export default {
  name: 'DateStripeDay',
  props: {
    day: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isToday() {
      if (!this.day) return false
      const today = $dayjs()
      return today.isSame(this.day.dateObject, 'day')
    },
    isWeekend() {
      if (!this.day) return false

      // TODO: Not locale aware, uses ISO Weekday: https://day.js.org/docs/en/get-set/iso-weekday#docsNav
      const weekDay = $dayjs(this.day.dateObject).isoWeekday()

      // Sat: 6, Sun: 7
      return weekDay === 6 || weekDay === 7
    },
    compTitle() {
      return $dayjs(this.day.dateObject).format('ll')
    },
  },
  methods: {
    clickedDay() {
      if (!this.selected) {
        this.$emit('handle-click', this.day)
      }
    },
  },
}
</script>

<template>
  <div class="text-center">
    <v-card
      :class="[
        selected
          ? 'blue white--text custom-elevation'
          : 'elevation-0 overflow-hidden',
        isToday ? 'border border--blue' : '',
        'text-center rounded-lg transparent mb-2 py-3 px-1',
      ]"
      :title="compTitle"
      @click="clickedDay"
    >
      <div :class="[isWeekend ? 'opacity-5' : '', '']">
        <div class="day-name caption">
          {{ day.displayStringDayName }}
        </div>
        <div class="day-number text-h6 font-weight-medium">
          {{ day.displayString }}
        </div>
      </div>
    </v-card>
    <div v-if="counter" class="day-nbookings">
      <v-badge class="font-weight-light" bottom :content="counter" inline>
      </v-badge>
    </div>
  </div>
</template>
